module.exports = __webpack_public_path__ + "img/receipt-white.9121d59e.svg";